module.exports = __webpack_public_path__ + "img/logo-feature-gslc.b1cfbcec.png";